module.exports = {
  v: '1.0.4'
};



// WEBPACK FOOTER //
// ./src/version.js